import React, {FC} from 'react';

import {useLocalize} from '../../../../../../../libs/shared/core/src/helpers/internationalization/internationalizationContext';
import {defineMessage} from '../../../../../../../libs/shared/core/src/helpers/internationalization/message';
import {TextAreaBox} from '../../../../../../../libs/shared/ui/src/components/boxedInputs/textAreaBox';
import {VisualSizesEnum} from '../../../../../../../libs/shared/ui/src/styles/commonStyles';
import {StyledMacroInputDescriptionDiv} from './common/macroInputDropdownStyles';
import {MacroInputCommonProps} from './common/macroInputTypes';

/*
 * Props.
 */

interface MacroInputStringProps extends MacroInputCommonProps<string> {}

/*
 * Component.
 */

export const MacroInputString: FC<MacroInputStringProps> = ({value, onChange, label, description}) => {
  const localize = useLocalize();

  return (
    <TextAreaBox
      noMargin
      size={VisualSizesEnum.MEDIUM}
      value={value ?? ''}
      onChange={(newValue) => onChange(newValue)}
      label={label}
      shouldAutoResize
      isRequired
      placeholder={localize(
        defineMessage({
          id: 'macro-input-string-placeholder',
          message: 'Add text',
        }),
      )}
      message={<StyledMacroInputDescriptionDiv>{description}</StyledMacroInputDescriptionDiv>}
      shouldDisableBottomTextMargin
      boxStyles={{minHeight: 50}}
    />
  );
};
